// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomePageCategorySection-topCategoryContainer-A5Az3 {
    width: 100%;
    text-align: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    padding: 90px 0;
}

.HomePageCategorySection-topCategorySliderHeading-uHG0t {
    position: relative;
    font-size: 40px;
    font-weight: 700;
    line-height: 50px;
    color: var(--primary-foreground);
    word-break: break-word;
    margin-bottom: 48px;
}

.HomePageCategorySection-topCategorySliderWrapper-NXzfO {
    position: relative;
}

.HomePageCategorySection-topCategorySliderListItemBox-uycHm {
    border-radius: var(--radius-3);
    background: var(--secondary-gray-bg);
}

.HomePageCategorySection-topCategorySliderListItemImg-UIUOB {
    height: 184px;
    width: 100%;
    max-width: 100%;
    border-radius: 12px;
    padding: 12px;
}

.HomePageCategorySection-topCategorySliderListItemImg-UIUOB img {
    display: inline-block;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover;
    -o-object-position: center;
       object-position: center;
    border-radius: inherit;
}

.HomePageCategorySection-topCategorySliderListItemBox-uycHm:hover .HomePageCategorySection-topCategorySliderListItemImg-UIUOB img {
    -webkit-box-shadow: 0px 6px 14px 0px var(--shadow-4);
            box-shadow: 0px 6px 14px 0px var(--shadow-4);
}

.HomePageCategorySection-topCategorySliderListItemInfo-zzQYl {
    padding: 6px 24px 24px 24px;
}

.HomePageCategorySection-topCategorySliderListItemTitle-Jgf7w {
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
    color: var(--primary-foreground);
    margin-bottom: 6px;
    text-align: start;
}

.HomePageCategorySection-topCategorySliderListItemDesc-mZUg6 {
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    color: var(--secondary-foreground);
    margin-bottom: 0;
    text-align: start;
}

@media (max-width: 991px) and (min-width: 768px) {
    .HomePageCategorySection-topCategoryContainer-A5Az3 {
        padding: 60px 0;
    }

    .HomePageCategorySection-topCategorySliderHeading-uHG0t {
        font-size: 30px;
        line-height: 44px;
        margin-bottom: 36px;
    }
}

@media (max-width: 767px) {
    .HomePageCategorySection-topCategoryContainer-A5Az3 {
        padding: 48px 0;
    }

    .HomePageCategorySection-topCategorySliderHeading-uHG0t {
        font-size: 24px;
        line-height: 34px;
        margin-bottom: 30px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Home/HomePageCategorySection/HomePageCategorySection.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kBAAkB;IAClB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,oBAAiB;OAAjB,iBAAiB;IACjB,0BAAuB;OAAvB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,oDAA4C;YAA5C,4CAA4C;AAChD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kCAAkC;IAClC,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;AACJ","sourcesContent":[".topCategoryContainer {\n    width: 100%;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 90px 0;\n}\n\n.topCategorySliderHeading {\n    position: relative;\n    font-size: 40px;\n    font-weight: 700;\n    line-height: 50px;\n    color: var(--primary-foreground);\n    word-break: break-word;\n    margin-bottom: 48px;\n}\n\n.topCategorySliderWrapper {\n    position: relative;\n}\n\n.topCategorySliderListItemBox {\n    border-radius: var(--radius-3);\n    background: var(--secondary-gray-bg);\n}\n\n.topCategorySliderListItemImg {\n    height: 184px;\n    width: 100%;\n    max-width: 100%;\n    border-radius: 12px;\n    padding: 12px;\n}\n\n.topCategorySliderListItemImg img {\n    display: inline-block;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n    border-radius: inherit;\n}\n\n.topCategorySliderListItemBox:hover .topCategorySliderListItemImg img {\n    box-shadow: 0px 6px 14px 0px var(--shadow-4);\n}\n\n.topCategorySliderListItemInfo {\n    padding: 6px 24px 24px 24px;\n}\n\n.topCategorySliderListItemTitle {\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 28px;\n    color: var(--primary-foreground);\n    margin-bottom: 6px;\n    text-align: start;\n}\n\n.topCategorySliderListItemDesc {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 26px;\n    color: var(--secondary-foreground);\n    margin-bottom: 0;\n    text-align: start;\n}\n\n@media (max-width: 991px) and (min-width: 768px) {\n    .topCategoryContainer {\n        padding: 60px 0;\n    }\n\n    .topCategorySliderHeading {\n        font-size: 30px;\n        line-height: 44px;\n        margin-bottom: 36px;\n    }\n}\n\n@media (max-width: 767px) {\n    .topCategoryContainer {\n        padding: 48px 0;\n    }\n\n    .topCategorySliderHeading {\n        font-size: 24px;\n        line-height: 34px;\n        margin-bottom: 30px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topCategoryContainer": `HomePageCategorySection-topCategoryContainer-A5Az3`,
	"topCategorySliderHeading": `HomePageCategorySection-topCategorySliderHeading-uHG0t`,
	"topCategorySliderWrapper": `HomePageCategorySection-topCategorySliderWrapper-NXzfO`,
	"topCategorySliderListItemBox": `HomePageCategorySection-topCategorySliderListItemBox-uycHm`,
	"topCategorySliderListItemImg": `HomePageCategorySection-topCategorySliderListItemImg-UIUOB`,
	"topCategorySliderListItemInfo": `HomePageCategorySection-topCategorySliderListItemInfo-zzQYl`,
	"topCategorySliderListItemTitle": `HomePageCategorySection-topCategorySliderListItemTitle-Jgf7w`,
	"topCategorySliderListItemDesc": `HomePageCategorySection-topCategorySliderListItemDesc-mZUg6`
};
module.exports = ___CSS_LOADER_EXPORT___;
